<template>
  <b-card>
    <template #header>
      <span class="pull-left mt-2 mb-2"><strong>Transportschema</strong></span>
      <b-button type="button" class="pull-right" variant="primary"
                v-can="'transportschema aanpassen'" v-if="!editable"
                @click="editable = true">
        Bewerken
      </b-button>
    </template>
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col cols="12">
            <b-alert :show="feedback.show" :variant="feedback.variant" @dismissed="feedback.show=0" @dismiss-count-down="countDownChanged" dismissible>
              {{feedback.text}}
              <ul v-if="errors" class="mt-3">
                <li v-for="error in errors">{{error.toString()}}</li>
              </ul>
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" v-can="'transportschema aanpassen'">
            <p>Stel hier het standaard transportschema in voor deze locatie</p>
          </b-col>
          <b-col cols="12">
            <b-list-group class="table-list-group">
              <b-list-group-item>
                <b-row>
                  <b-col cols="12" md="2"><strong>Dag</strong></b-col>
                  <b-col cols="12" md="6"><strong>Instelling</strong></b-col>
                  <b-col cols="12" md="4"><strong>Startdatum</strong></b-col>
                </b-row>
              </b-list-group-item>
              <b-list-group-item v-for="(setting, index) in all_settings" :key="`renewal-setting-${setting.day}-${setting.id}`">
                <renewal-setting v-model="all_settings[index]" :editable="editable" />
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
        <b-row class="mt-4" v-can="'transportschema aanpassen'" v-if="!create">
          <b-col cols="12">
            <p class="mb-0"><em><strong>Let op! </strong>Alle bezorgdagen die al zijn aangemaakt voor de komende periode (zie ook deze pagina
                onder "Beschikbare transportdagen") zullen ongewijzigd blijven.</em></p>
          </b-col>
        </b-row>
        <b-row v-can="'transportschema aanpassen'" v-if="editable">
          <b-col cols="12">
            <hr>
            <b-button type="button" class="pull-right" @click.prevent="updateData" variant="primary">Transportschema opslaan</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import moment from 'moment';
import RenewalSetting from "./RenewalSetting";
import { updateData, getData } from '../../api';
import router from "@/router";

export default {
  name: 'delivery-slot-setter',
  props: {
    settings: {
      type: Array,
      default: () => [],
    },
    create: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RenewalSetting
  },
  data() {
    return {
      all_settings: [],
      editable: this.create,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      errors: null,
      saveButtonDisabled: false,
    }
  },
  methods: {
    async updateData() {
      this.errors = null;
      this.saveButtonDisabled = true;
      const settings = this.all_settings.map(item => {
        return {
            ...item,
            start_date: item.start_date ? moment(item.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
        }
      });
      const request = await updateData(`locations/${this.$route.params.id}/renewal-settings`, {
        settings
      });
      if (request.status === 200) {
        this.updateSettings(request.data.data);
        this.feedback.show = true;
        this.feedback.text = 'Transportschema is succesvol gewijzigd';
        this.feedback.variant = 'success';
        this.saveButtonDisabled = false;
        this.editable = false;
      } else {
        this.errors = request.data.errors;
        this.feedback.show = true;
        this.feedback.text = 'Er ging iets mis...';
        this.feedback.variant = 'danger';
        this.saveButtonDisabled = false;
      }
      this.$router.go(0);
    },
    countDownChanged(dismissCountDown) {
      this.feedback.dismissCountDown = dismissCountDown
    },
    updateSettings(settings) {
      this.$set(this, 'all_settings', []);

      const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
      days.forEach((day) => {
        let obj = settings.find(x => x.day === day);

        if (!obj) {
          obj = {
            id: null,
            day: day,
            setting: null,
            start_date: null,
          }
        }

        this.all_settings.push(obj);
      });
    }
  },
  mounted() {
    this.updateSettings(this.settings);
  },
  watch: {
    all_settings: {
      handler: function(value) {
        this.$emit('input', value);
      },
      deep: true,
    }
  }
}

</script>
